import { z } from 'zod';
import { AttemptSchema } from '@pages/workOrderAttempts/attemptsSchema';
import {
  HiAttemptOwnerFieldsSchema,
  HiAttemptPropertyAndCommentsSchema,
  HiAttemptStep2Schema,
  HiAttemptVacancyChecklistSchema,
  type HiAttemptVacancyChecklistValues,
} from '@/pages/homeInspection/hiAttempt.schema';

export const PsFirstAttemptServiceStepSchema = z.object({
  serviceAttempt: AttemptSchema,
});

export const PsFirstAttemptOwnerStepSchema = HiAttemptOwnerFieldsSchema;

export const PsFirstAttemptTenantStepSchema = HiAttemptStep2Schema;

export const PsFirstAttemptPropertyStepSchema = HiAttemptPropertyAndCommentsSchema;

export const PsFirstAttemptVacancyStepSchema = z.object({
  vacancyChecklist: HiAttemptVacancyChecklistSchema.optional().nullable(),
});

export type PsFirstAttemptHiFormValues = z.infer<typeof PsFirstAttemptServiceStepSchema> &
  z.infer<typeof HiAttemptOwnerFieldsSchema> &
  z.infer<typeof HiAttemptStep2Schema> &
  z.infer<typeof HiAttemptPropertyAndCommentsSchema> & {
    vacancyChecklist?: HiAttemptVacancyChecklistValues | null;
  };

export const PS_FIRST_ATTEMPT_HI_STEP_SCHEMAS = [
  PsFirstAttemptServiceStepSchema,
  PsFirstAttemptOwnerStepSchema,
  PsFirstAttemptTenantStepSchema,
  PsFirstAttemptPropertyStepSchema,
  PsFirstAttemptVacancyStepSchema,
] as const;
